module.exports = __webpack_public_path__ + "static/media/Kalyon_Turchia.4c47ca96.png";